import { BaseModel } from '../../_base/crud';
import { Address } from './address.model';
import { SocialNetworks } from './social-networks.model';

export class Customer extends BaseModel {
  uuid: string;
  customername: string;
  email: string;
  pic: string;
  phone: string;
  address: Address;
  fax: string;
  contactPerson: string; 
  customertype: string; 
  jobtitle: string;
  discountRate: any;
  originPerson:string;
  userId:string;



  clear(): void {
    this.uuid = '';
    this.customername = '';
    this.email = '';
    this.pic = '';
    this.phone = '';
    this.fax = '';
    this.contactPerson = '';
    this.customertype = '';
    this.jobtitle = '';
    this.phone = '';
    this.discountRate = '';
    this.originPerson = '';
    this.address = new Address();
    this.address.clear();
    this.userId= '';
  }
}
